import React from "react";
import { CheckIcon } from "lucide-react";
import { planWeeks } from "../data/planWeeks";
export function PlanSection() {
  return <section id="plan" className="bg-caramel-500 py-14 text-cocoa-950 sm:py-28" data-id="element-204" data-mp="50sqneg4hd4i">
      <div className="mx-auto max-w-6xl px-5" data-id="element-205" data-mp="jxjohja5egs0">
        <div className="max-w-3xl" data-id="element-206" data-mp="ju5q0m4lurpu">
          <p className="font-display text-xl italic text-cocoa-800" data-id="element-207" data-mp="ex5s4yhwsv9t">El corazón del método</p>
          <h2 className="mt-3 font-display text-4xl font-semibold leading-tight sm:text-6xl" data-id="element-208" data-mp="swos340kh0b1">
            Tu recorrido de 30 días, semana a semana
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-cocoa-800" data-id="element-209" data-mp="nw9d680mzkqy">
            Unos minutos al día, una tarea a la vez. Al llegar al día 30, tendrás tu emprendimiento armado y listo para recibir pedidos.
          </p>
        </div>

        <div className="relative mt-8 sm:mt-14" data-id="element-210" data-mp="1bn6fct2mr3p0">
        <div className="absolute left-0 right-0 top-[22px] hidden h-px bg-cocoa-950/25 lg:block" aria-hidden="true" data-id="element-211" data-mp="1bnxyh4f1j8ye" />
        <ol className="relative grid gap-4 lg:grid-cols-4 lg:gap-0" data-id="element-212" data-mp="17k9s2p25ajeq">
          {planWeeks.map((w, i) => <li key={w.week} className="relative grid grid-cols-[auto_1fr] gap-5 lg:grid-cols-1 lg:grid-rows-[auto_1fr] lg:pr-6" data-id="element-213" data-mp="2vf1f0iqzlepw" data-mpi={i}>
              <span className="relative z-10 flex h-11 w-11 items-center justify-center rounded-full bg-cocoa-950 font-display text-lg italic text-caramel-300" data-id="element-214" data-mp="30duq64iswtmw">
                {i + 1}
              </span>
              <div className="flex flex-col rounded-2xl bg-cream-50 p-6 text-cocoa-900 shadow-[0_12px_30px_-18px_rgba(28,17,11,0.6)]" data-id="element-215" data-mp="3ab8yfgukmc44">
                <p className="text-xs font-semibold uppercase tracking-wider text-caramel-600" data-id="element-216" data-mp="3ebssucnrf1mk">{w.week} · {w.days}</p>
                <h3 className="mt-2 font-display text-2xl font-semibold" data-id="element-217" data-mp="3o3p4kqirqq99">{w.title}</h3>
                <ul className="mt-4 space-y-2.5" data-id="element-218" data-mp="3o5t99aohrtal">
                  {w.tasks.map(t => <li key={t} className="flex gap-2.5 text-[15px] leading-snug text-cocoa-700" data-id="element-219" data-mp="3t0ozc5a646l2">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-caramel-600" aria-hidden="true" data-id="element-220" data-mp="1ue4wrzny42p" />
                      {t}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ol>
        </div>

        <div className="mt-8 rounded-2xl bg-cocoa-950 p-6 text-center text-cream-100 sm:mt-14 sm:p-10" data-id="element-221" data-mp="3i4bxzgg37y7f">
          <p className="mx-auto max-w-2xl font-display text-2xl leading-snug" data-id="element-222" data-mp="3db9394zkqipn">
            Lo más fácil de este plan: <span className="italic text-caramel-300" data-id="element-223" data-mp="3r2nozjkv8y0e">nunca tienes que adivinar el siguiente paso.</span>
          </p>
        </div>
      </div>
    </section>;
}